import { createAction } from 'redux-act';
import { IKeynote } from 'modules/schemas';

export const fetchKeynotes = createAction('Fetch Keynotes');
export const fetchKeynotesSuccess = createAction<IKeynote[]>('Fetch Keynotes Success');
export const fetchKeynotesFailed = createAction('Fetch Keynotes Failed');
